<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-06 15:35:08
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-12 01:17:34
-->
<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-05 21:42:33
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 01:07:15
-->
<template>
  <div class="table">
    <a-tabs>
      <a-tab-pane key="1" tab="项目管理">
         <div class="tool-box"  @click="$router.push({path: '/userCenter/projectadd'})">
          <a-button  type="primary">发布项目</a-button>
        </div>
        <a-table
          :data-source="data"
          :columns="columns"
          :scroll="{ x: true }"
          rowKey="id"
          style="width: 100%"
        >
               <span slot="status" slot-scope="text">{{ fmtStatus(text) }}</span>
          <template slot="operation" slot-scope="text, record">
            <a
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleEdit(record)"
              >修改</a
            >
            <a-popconfirm
              v-if="userInfo && userInfo.type != '代理机构'"
              title="请确认是否删除?"
                okText="确定" cancelText="取消"
              @confirm="() => onDelete(record)"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      width="800px"
      @ok="handleOk"
        cancelText="关闭"
      okText="确定"
      @cancel="visible = false"
    >
      <a-form-model v-model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
       
            <a-form-model-item label="标题">
              <a-input v-model="form.title" :disabled="!isEdit" />
            </a-form-model-item>
    
    
            <a-form-model-item label="联系人">
              <a-input v-model="form.concat" :disabled="!isEdit" />
            </a-form-model-item>
        
            <a-form-model-item label="联系电话">
              <a-input v-model="form.phone" :disabled="!isEdit" />
            </a-form-model-item>
      
     
            <a-form-model-item label="金额">
              <a-input v-model="form.money" :disabled="!isEdit" />
            </a-form-model-item>
     
    

        <a-form-model-item label="简介">
          <a-textarea v-model="form.remark" />
        </a-form-model-item>

            <a-form-model-item label="附件">
              <a-upload
                :showUploadList="false"
                :locale="locale"
                name="file"
                action="/newapp/api/common/attachment/"
                @change="handleChange"
              >
                <a-button> <a-icon type="upload" /> 上传 </a-button>
              </a-upload>

              <viewer>
                <img
                  :src="form.videoIdUrl"
                  style="margin: 8px; cursor: pointer"
                  width="100%"
                  height="100"
                />
              </viewer>
              <!-- <img  width="50" height="60" :src="'/app/common/attachment?id=' + attmentId" /> -->
            </a-form-model-item>
       
            <a-form-model-item label="内容">
              <!-- <div id="editor"></div> -->
              <quill-editor
                v-model="form.content"
                ref="myQuillEditor"
                :options="editorOption"
                @focus="onEditorFocus($event)"
                @blur="onEditorBlur($event)"
                @change="onEditorChange($event)"
              >
              </quill-editor>
              <!-- <a-textarea v-model="form.content" :disabled="!isEdit" /> -->
            </a-form-model-item>
  
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "项目标题",
    dataIndex: "title",
    key: "title",
    width: 250,
    ellipsis: true,
  },
  {
    title: "联系人",
    dataIndex: "concat",
    key: "concat",
    width: 120,
    ellipsis: true,
  },
  {
    title: "联系电话",
    dataIndex: "phone",
    key: "phone",
    width: 180,
    ellipsis: true,
 
  },
  {
    title: "金额",
    dataIndex: "money",
    key: "money",
    width: 120,
    ellipsis: true,
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    width: 120,
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "id",
    scopedSlots: { customRender: "operation" },
    fixed: "right",
  },
];
import { quillEditor } from "vue-quill-editor"; // 调用富文本编辑器
import quillConfig from "@/util/quill-config.js";
import request from "../util/request";
import qs from "qs";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  name: "user-center-project",
  components: {
    quillEditor,
  },
  data() {
    return {
      editorOption: quillConfig,
      locale,
      data: [],
      columns,
      type: [],
      org: [],
      page: {
        page: 1,
        pageSize: 999,
      },
      title: "",
      visible: false,
      visible2: false,
      confirmLoading: false,
      isEdit: false,
      parents: [],
      form: {},
      form2: {},
      userInfo: {},
      industry: [],
      area: [],
      maturity: [],
      trade: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }
    let v = this.$route.query.visible;
    this.visible = v == 1;
    if (this.visible) {
      this.isEdit = true;
    }

    this.queryList();
    this.queryDictStatus();
    // this.queryIndustry();
    // this.queryMaturity();
    // this.queryMode();
  },
  methods: {
    onEditorBlur(editor) {
      console.log("editor blur!", editor);
    },
    onEditorFocus(editor) {
      console.log("editor focus!", editor);
    },
    onEditorReady(editor) {
      console.log("editor ready!", editor);
    },
    onEditorChange({ editor, html, text }) {
      console.log("editor change!", editor, html, text);
      this.content = html;
    },
    handleAdd() {
      this.title = "发布项目";
      this.isEdit = true;
      this.form = {};
      this.visible = true;
    },
    queryMaturity() {
      request({
        url: "/client/common/select/dict/list",
        params: { key: "PROJECT_MATURITY" },
      }).then((res) => {
        this.maturity = res.data;
      });
    },
    queryArea() {
      request({
        url: "/client/common/select/area",
      }).then((res) => {
        this.area = res.data;
      });
    },
    queryMode() {
      request({
        url: "/client/common/select/dict/list",
        params: { key: "MONEY_MODE" },
      }).then((res) => {
        this.trade = res.data;
      });
    },
    handleChange(info) {
      if (info.file.status === "done") {
        // if (this.form.fileIds) {
        //   this.form.videoId=info.file.response.data.url;
        // } else this.form.fileIds = [info.file.response.data.url];
        this.form.videoId = info.file.response.data.url;
        this.form.videoIdUrl =info.file.response.data.url;
        console.log(this.form.videoId);
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleOpenChange1(open) {
      if (open) {
        this.dataMode = "time";
      }
    },
    handlePanelChange1(value, mode) {
      this.dataMode = mode;
    },
    queryIndustry() {
      request({
        url: "/api/client/common/select/industry",
      }).then((res) => {
        this.industry = res.data;
      });
    },
    handleDetail(record) {
      // this.form = record;
      request({
        url: `/api/center/order/trademarkregister/${record.id}`,
      }).then((res) => {
        this.visible = true;
        this.title = "详情";
        this.isEdit = false;
        this.form = res.data;
        this.form.videoIdUrl = res.data.videoId;
      });
    },
    onDelete(record) {
      request({
        url: "/api/center/project/" + record.id,
        method: "delete",
      }).then((res) => {
        this.$message.info(res.msg);
        this.queryList();
      });
    },
    handleEdit(record) {
      this.visible = true;
      this.title = "修改";
      request({
        url: "/api/center/project/" + record.id,
        method: "get",
      }).then((res) => {
        if (res.code == "200") {
          this.form = res.data;
          this.form.videoIdUrl = res.data.videoId;
        } else {
          this.$message.error(res.msg);
        }
      });
      this.isEdit = true;
    },
    handleOk() {
      console.log(qs.stringify(this.form));
      if (this.isEdit) {
        request({
          url: "/api/center/project/",
          method: this.title == "修改" ? "put" : "post",
          data: qs.stringify(this.form),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((res) => {
          if (res.msg == "success") {
            this.$message.info("操作成功");
            this.visible = false;
            this.form2 = {};
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.visible = false;
        this.form2 = {};
      }
    },
  queryDictStatus() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "project_status",
        },
      }).then((res) => {
        console.log("dict", res);
        this.status = res.data;
      });
    },
    fmtStatus(text) {
      const result = this.status.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    queryList() {
      request({
        url: "/api/center/project/list",
        params: this.page,
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = false;
    },
  },
};
</script>

<style lang="less">
.search-box-product {
  width: 500px;
  margin: 0 20px 20px 0;
}
</style>
